<template>
  <div class="gauge">
    <span id="topTarget"></span>
    <CheckList :survey="survey" :curGaugeType="curGaugeType" />
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue'
import CheckList from '@/views/WorkPlace/Container/Gauge/components/checkList'
import { gaugeDetailApi } from '@/api/workPlace/gauge'
const props = defineProps({
  params: {
    type: Object,
    default: () => ({
      surveyId: null,
      surveySendId: null
    })
  }
})

const survey = ref({})
const curGaugeType = ref(0)
const gaugeDetail = async query => {
  survey.value = await gaugeDetailApi(query)
  curGaugeType.value = survey.value.guidanceStatus
}
onMounted(() => {
  gaugeDetail(props.params)
})
</script>

<style lang="scss" scoped>
.gDetailModal {
  .ant-modal-body {
    padding: 16px 86px;
    max-height: 760px;
    overflow: auto;
  }
}
</style>
